define('uikit/extra/floated',{
  LEFT: 'left',
  RIGHT: 'right'
});

